document.addEventListener('click', function (e) {
    // Toggle open/close
    const toggleBtn = e.target.closest('.disclosure__button');
    if (toggleBtn) {
      const disclosure = toggleBtn.closest('.disclosure');
      const listWrapper = disclosure && disclosure.querySelector('.disclosure__list-wrapper');
      if (!listWrapper) return;

      const isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!isOpen));
      listWrapper.hidden = isOpen; // if open -> hide; if closed -> show
      return;
    }

    // Close button
    const closeBtn = e.target.closest('.country-selector__close-button');
    if (closeBtn) {
      const disclosure = closeBtn.closest('.disclosure');
      const toggleBtn = disclosure && disclosure.querySelector('.disclosure__button');
      const listWrapper = disclosure && disclosure.querySelector('.disclosure__list-wrapper');
      if (!toggleBtn || !listWrapper) return;

      toggleBtn.setAttribute('aria-expanded', 'false');
      listWrapper.hidden = true;
      return;
    }

    // Click on an option: set country_code and submit the localization form
    const optionLink = e.target.closest('a.disclosure__link[data-value]');
    if (optionLink) {
      e.preventDefault();
      const disclosure = optionLink.closest('.disclosure');
      const form = optionLink.closest('form');
      if (!form) return;

      const countryCodeInput = form.querySelector('input[name="country_code"]');
      if (!countryCodeInput) return;

      countryCodeInput.value = optionLink.dataset.value;
      form.submit();
      return;
    }

    // Click outside -> close (optional but nice)
    const openDisclosureBtn = document.querySelector('.disclosure__button[aria-expanded="true"]');
    if (openDisclosureBtn) {
      const openDisclosure = openDisclosureBtn.closest('.disclosure');
      if (openDisclosure && !openDisclosure.contains(e.target)) {
        const listWrapper = openDisclosure.querySelector('.disclosure__list-wrapper');
        openDisclosureBtn.setAttribute('aria-expanded', 'false');
        if (listWrapper) listWrapper.hidden = true;
      }
    }
  });